module.exports = __webpack_public_path__ + "static/media/logo_horizontal_2020.7b793e41.png";